import { componentName, TotpImageClass } from './TotpImageClass';

customElements.define(componentName, TotpImageClass);

export { TotpImageClass, componentName };
